"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.spacing = void 0;
var spacing_1 = __importDefault(require("../tokens/spacing"));
exports.spacing = spacing_1.default;
//# sourceMappingURL=spacing.js.map